import { ComparisonItem, Value } from "./interface"

export { colors } from './colors'
export { comparisonItems } from './comparison-items'
export { productSpecs } from './product-specs'

export const getValue = <T>(value: Value<T> | undefined): T | null => {
  if (!value) return null
  if (typeof value === 'object' && 'value' in value) return value.value
  return value
}

export const getMergedItem = <T>(item: ComparisonItem, value: Value<any> | undefined): ComparisonItem => {
  const override = typeof value === 'object' && 'override' in value ? value.override : {}

  return Object.assign({}, item, override)
}
